//text = 要斷行的文字
//breakIndex = 要在第幾個字之後斷行
//limit = 是否有字數限制？大於limit才執行斷行
String.prototype.textBreak = function (breakIndex, limit) {
  const text = this.valueOf();
  if (!text) return text;
  else if (!breakIndex) return text;
  else if (limit) {
    if (text.toString().length > limit) return text.slice(0, breakIndex) + '<br />' + text.slice(breakIndex);
    else return text;
  } else {
    if (text.toString().length <= breakIndex) return text;
    else return text.slice(0, breakIndex) + '<br />' + text.slice(breakIndex);
  }
};
